<script>
  import FetchController from './FetchController.vue'
  export default {
    extends: FetchController,
    methods: {
      getSuratTitle(steamHex) {
        return this.fetchData(`/surat/list-warga-surat?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve, reject) => {
              if(data) {
                resolve(data.result)
              } else {
                reject(data.msg);
              }
            })
          })
      },
      saveSurat(steamHex, suratContent, suratTitle, fullname, pekerjaan, nomorSurat, firstname, lastname) {
        return this.fetchData('/surat/save-surat', 'POST', {steamHex, suratContent, suratTitle, fullname, pekerjaan, nomorSurat, firstname, lastname}, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      getSurat(steamHex, id, surattitle) {
        if(steamHex) {
          return this.fetchData(`/surat/get-surat?steamHex=${steamHex}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
        } else if(id) {
          const title = surattitle.replace(/\s+/g, '')
          return this.fetchData(`/surat/get-surat?id=${id}&surattitle=${title}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
        }
      },
      getNomorSurat(surattitle) {
        if(surattitle) {
          return this.fetchData(`/surat/last-nomor-surat?surattitle=${surattitle}`, 'GET', null, true, false)
            .then(res => {
              return res.json()
            })
            .then(data => {
              return new Promise((resolve) => {
                resolve(data)
              })
            })
        }
      },
      getTemplateSurat(judulSurat) {
        return this.fetchData(`/surat/template-surat?judulSurat=${judulSurat}`, 'GET', null, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      saveSuratHewan(steamHex, suratContent, suratTitle, fullname, pekerjaan, img, filename) {
        return this.fetchData('/surat/sertifikat-hewan', 'POST', {steamHex, suratContent, suratTitle, fullname, pekerjaan, img, filename}, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      editSurat(steamHex, suratContent, fullname, pekerjaan, suratId, suratTitle) {
        return this.fetchData('/surat/edit-surat', 'PUT', {steamHex, suratContent, fullname, pekerjaan, suratId, suratTitle}, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      editSuratHewan(steamHex, suratContent, fullname, pekerjaan, img, filename, suratId) {
        return this.fetchData('/surat/edit-sertifikat-hewan', 'PUT', {steamHex,suratContent, fullname, pekerjaan, img, filename, suratId}, true, false)
          .then(res => {
            return res.json()
          })
          .then(data => {
            return new Promise((resolve) => {
              resolve(data)
            })
          })
      },
      sendImage(canvas, suratTitle, nomorSurat) {
        var  printer
        if(suratTitle === 'Kontrak Kerja' || suratTitle === 'Surat Izin Opang' || suratTitle === 'Surat Kartu Pekerja' || suratTitle === 'Surat Magang') {
          printer = 'staff'
        } else {
          printer = suratTitle
        }
        this.fetchData('/surat/post-image', 'POST', {imgBase64: canvas, printer, nomorSurat, suratTitle}, true, false)
        .then(res => {
          return new Promise((resolve, reject) => {
            if(!res.ok) {
              reject();
            } else {
              resolve();
            }
          })
        })
      }
    }
  }
</script>